import React from 'react';
import cx from 'classnames';


export const EmptyItemMargin = ({ className,...props }) => <EmptyItem className={cx(className, 'margin')}{...props} />


export const EmptyItem = ({ children, className, size = 'm', align = "center", ...props }) => {
  return (
  <div className={cx("g-empty-item", className, size, align)} {...props}>
    <div className="empty-wrap">{children}</div>
  </div>);
}
export default EmptyItem;